import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import type { InsuranceProduct } from 'src/interfaces/insuranceProduct'
import { InsuranceProductFormContent } from './InsuranceProductFormContent'
import { insuranceProductFormValidator } from './InsuranceProductForm.validator'
import type {
  InsuranceProductFormMode,
  InsuranceProductFormValues,
} from './InsuranceProductForm.interface'

interface Props {
  formId: string
  mode: InsuranceProductFormMode
  insuranceProduct: InsuranceProduct | null
  onSubmit(values: InsuranceProductFormValues): void
}

const InsuranceProductFormComponent = ({ formId, mode, insuranceProduct, onSubmit }: Props) => {
  const initialValues = useMemo<InsuranceProductFormValues>(() => {
    return {
      name: insuranceProduct?.name ?? '',
      description: insuranceProduct?.description ?? '',
      explanation: insuranceProduct?.explanation ?? '',
    }
  }, [insuranceProduct])

  const handleSubmit = useCallback(
    (values: InsuranceProductFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<InsuranceProductFormValues>
      initialValues={initialValues}
      validationSchema={insuranceProductFormValidator}
      // Reopening the modal on a different row must reseed the fields.
      enableReinitialize
      onSubmit={handleSubmit}
    >
      <Form id={formId}>
        <InsuranceProductFormContent mode={mode} />
      </Form>
    </Formik>
  )
}

export const InsuranceProductForm = memo(InsuranceProductFormComponent)
